// Shared helpers for the TFVF Training area.
import React from 'react';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${API_BASE}/api`;

/** Return an Authorization header when a token is available. */
export const authHeaders = (token) => (token ? { Authorization: `Bearer ${token}` } : {});

/** Ultra-lightweight markdown renderer. Not battle-hardened, deliberately —
 *  the source doctx-extracted body is already tame. Handles headings, bold,
 *  italic, quotes, lists, inline code and paragraph breaks. */
export function renderMarkdown(md) {
  if (!md) return null;
  const lines = String(md).split('\n');
  const out = [];
  let listBuf = null;
  const flushList = () => {
    if (listBuf) {
      out.push(<ul key={`ul-${out.length}`} className="list-disc pl-6 mb-2">{listBuf.map((li, i) => <li key={i}>{inline(li)}</li>)}</ul>);
      listBuf = null;
    }
  };
  const inline = (t) => {
    // Order matters: escape, then bold, italic, code.
    const nodes = [];
    let s = t;
    const tokens = s
      .replace(/\*\*(.+?)\*\*/g, '⟦B⟧$1⟦/B⟧')
      .replace(/\*(.+?)\*/g, '⟦I⟧$1⟦/I⟧')
      .replace(/`(.+?)`/g, '⟦C⟧$1⟦/C⟧')
      .split(/(⟦[BIC]⟧.+?⟦\/[BIC]⟧)/g);
    tokens.forEach((tok, i) => {
      if (!tok) return;
      const b = tok.match(/^⟦B⟧(.+?)⟦\/B⟧$/);
      const it = tok.match(/^⟦I⟧(.+?)⟦\/I⟧$/);
      const c = tok.match(/^⟦C⟧(.+?)⟦\/C⟧$/);
      if (b) nodes.push(<strong key={i}>{b[1]}</strong>);
      else if (it) nodes.push(<em key={i}>{it[1]}</em>);
      else if (c) nodes.push(<code key={i}>{c[1]}</code>);
      else nodes.push(<React.Fragment key={i}>{tok}</React.Fragment>);
    });
    return nodes;
  };
  lines.forEach((ln, i) => {
    const line = ln.replace(/\s+$/, '');
    if (!line.trim()) { flushList(); return; }
    if (line.startsWith('### ')) { flushList(); out.push(<h3 key={i}>{inline(line.slice(4))}</h3>); return; }
    if (line.startsWith('## '))  { flushList(); out.push(<h2 key={i}>{inline(line.slice(3))}</h2>); return; }
    if (line.startsWith('# '))   { flushList(); out.push(<h1 key={i}>{inline(line.slice(2))}</h1>); return; }
    if (line.startsWith('> '))   { flushList(); out.push(<blockquote key={i}>{inline(line.slice(2))}</blockquote>); return; }
    if (line.startsWith('- ') || line.startsWith('• ') || line.startsWith('* ')) {
      listBuf = listBuf || [];
      listBuf.push(line.slice(2));
      return;
    }
    flushList();
    out.push(<p key={i}>{inline(line)}</p>);
  });
  flushList();
  return <div className="tf-prose">{out}</div>;
}

/** Human-friendly percentage — always 1 decimal. */
export const pct = (n) => (n == null ? '—' : `${Number(n).toFixed(n % 1 === 0 ? 0 : 1)}%`);

export const ROLE_LABELS = {
  membership_consultant: 'Membership Consultant',
  reception:             'Reception',
  club_manager:          'Club Manager',
  regional_leader:       'Regional / Program Leader',
};
